<div class="main-container">
    <div class="box">
        <h2>Fonts!</h2>
        <p class="font-overline">Font overline: Lorem ipsum dolor sit amet</p>
        <h2 class="font-h2">Font H2: Lorem ipsum dolor sit amet</h2>
        <p class="font-subtitle">Font subtitle: Lorem ipsum dolor sit amet</p>
        <p class="font-button">Font button: Lorem ipsum dolor sit amet</p>
        <p class="font-body1">Font body1: Lorem ipsum dolor sit amet</p>
        <p class="font-body2">Font body2: Lorem ipsum dolor sit amet</p>
        <p class="font-body2-link">Font body2 link: Lorem ipsum dolor sit amet</p>
        <p class="font-body-small">Font body small: Lorem ipsum dolor sit amet</p>
        <div class="font-caption">Font caption: Lorem ipsum dolor sit amet</div>
    </div>
    <div class="box">
        <h2>Notification cards!</h2>
        <app-notification-card cardType="info"
                               leftIcon="save">
            <div class="text font-body2-header">Verlies je ontwerp niet!</div>
            <div class="text font-body2">Klik op opslaan om je ontwerp te bewaren.</div>
        </app-notification-card>
        <app-notification-card cardType="info"
                               leftIcon="edit">
            <div class="text font-body2-header">Lange tekst</div>
            <div class="text font-body2">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                ullamco
                laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
                velit
                esse
                cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa
                qui
                officia
                deserunt mollit anim id est laborum.
            </div>
        </app-notification-card>
        <app-notification-card cardType="info">
            <div class="text font-body2">Korte tekst</div>
        </app-notification-card>
        <app-notification-card cardType="warning"
                               leftIcon="warn">
            <div class="text font-body2">Je kunt alleen buitenste torens verwijderen.</div>
        </app-notification-card>
        <button (click)="demoNotification('Er gaat iets goed!', allEnumIcons.questionmark, notificationCardType.info)">
            Show info notification!
        </button>
        <button (click)="demoNotification('Er gaat iets fout!', allEnumIcons.warn, notificationCardType.warning)">
            Show error notification!
        </button>
        <button (click)="demoNotification('Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod\n'+
'      tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco\n'+
'      laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\n'+
'      cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia\n'+
'      deserunt mollit anim id est laborum.', allEnumIcons.warn, notificationCardType.warning)">
            Show large error notification!
        </button>
    </div>

    <div class="box">
        <h2>Buttons!</h2>
        <app-button
            [buttonType]="'primary'"
            [leftIcon]="'cart'"
            [rightIcon]="'cart'"
            [label]="'primary 2 icons'"
        ></app-button>
        <app-button
            [buttonType]="'secondary'"
            [leftIcon]="'cart'"
            [rightIcon]="'cart'"
            [label]="'secondary 2 icons'"
        ></app-button>
        <app-button
            [buttonType]="'active-step'"
            [leftIcon]="'cart'"
            [rightIcon]="'cart'"
            [label]="'active step 2 icons'"
        ></app-button>
        <app-button
            [buttonType]="'inactive-step'"
            [leftIcon]="'cart'"
            [rightIcon]="'cart'"
            [label]="'inactive step 2 icons'"
        ></app-button>
        <app-button
            [buttonType]="'cart'"
            [leftIcon]="'cart'"
            [rightIcon]="'cart'"
            [label]="'cart 2 icons'"
        ></app-button>
        <app-button
            [buttonType]="'primary'"
            [rightIcon]="'cart'"
            [label]="'primary right icon'"
        ></app-button>
        <app-button
            [buttonType]="'secondary'"
            [rightIcon]="'cart'"
            [label]="'secondary right icon'"
        ></app-button>
        <app-button
            [buttonType]="'active-step'"
            [rightIcon]="'cart'"
            [label]="'active step right icon'"
        ></app-button>
        <app-button
            [buttonType]="'inactive-step'"
            [rightIcon]="'cart'"
            [label]="'inactive step right icon'"
        ></app-button>
        <app-button
            [buttonType]="'primary'"
            [leftIcon]="'cart'"
            [label]="'primary left icon'"
        ></app-button>
        <app-button
            [buttonType]="'secondary'"
            [leftIcon]="'cart'"
            [label]="'secondary left icon'"
        ></app-button>
        <app-button
            [buttonType]="'active-step'"
            [leftIcon]="'cart'"
            [label]="'active step left icon'"
        ></app-button>
        <app-button
            [buttonType]="'inactive-step'"
            [leftIcon]="'cart'"
            [label]="'inactive step left icon'"
        ></app-button>
        <app-button
            [buttonType]="'primary'"
            [leftIcon]="'cart'"
            [label]="'primary left icon disabled'"
            [disabled]="true"
        ></app-button>
        <app-button
            [buttonType]="'secondary'"
            [leftIcon]="'cart'"
            [label]="'secondary left icon disabled'"
            [disabled]="true"
        ></app-button>
        <app-button
            [buttonType]="'active-step'"
            [leftIcon]="'cart'"
            [label]="'active step left icon disabled'"
            [disabled]="true"
        ></app-button>
        <app-button
            [buttonType]="'inactive-step'"
            [leftIcon]="'cart'"
            [label]="'inactive step left icon disabled'"
            [disabled]="true"
        ></app-button>
        <app-button
            [buttonType]="'cart'"
            [leftIcon]="'cart'"
            [label]="'cart left icon disabled'"
            [disabled]="true"
        ></app-button>
        <app-button
            [buttonType]="'primary'"
            [label]="'primary no icon'"
        ></app-button>
        <app-button
            [buttonType]="'secondary'"
            [label]="'secondary no icon'"
        ></app-button>
        <app-button
            [buttonType]="'active-step'"
            [label]="'active step no icon'"
        ></app-button>
        <app-button
            [buttonType]="'inactive-step'"
            [label]="'inactive step no icon'"
        ></app-button>
        <app-button
            [buttonType]="'cart'"
            [label]="'cart no icon'"
        ></app-button>
        <app-button
            [buttonType]="'primary'"
            [leftIcon]="'cart'"
            [rightIcon]="'cart'"
            [label]="'primary fill parent 2 icons'"
            [fillParent]="true"
        ></app-button>
        <app-button
            [buttonType]="'secondary'"
            [leftIcon]="'cart'"
            [rightIcon]="'cart'"
            [label]="'secondary fill parent 2 icons'"
            [fillParent]="true"
        ></app-button>
        <app-button
            [buttonType]="'primary'"
            [label]="'primary with clicktest for disablednes'"
            [(disabled)]="buttonDisabled"
            (onClick)="buttonClick()"
        ></app-button>
        <app-button
            [buttonType]="'primary'"
            [smallButton]="true"
            [label]="'primary small no icon'"
        ></app-button>
        <app-button
            [buttonType]="'primary'"
            [smallButton]="true"
            [leftIcon]="'checkmark'"
            [label]="'primary small left checkmark'"
        ></app-button>
        <app-button
            [buttonType]="'primary'"
            [smallButton]="true"
            [label]="'1'"
            [circleButton]="true"
        ></app-button>
        <app-button
            [buttonType]="'primary'"
            [leftIcon]="'cart'"
            [circleButton]="true"
        ></app-button>

        <app-icon-series-button
            class="clickable"
            [buttons]="[icons[0]]"
        ></app-icon-series-button>

        <app-icon-series-button
            class="clickable"
            [buttons]="[icons[0], icons[1]]"
        ></app-icon-series-button>

        <app-icon-series-button
            class="clickable"
            [buttons]="icons"
        ></app-icon-series-button>

        <app-icon-series-button
            class="clickable"
            [manualReactivation]="true"
            [buttons]="icons"
            (onClick)="buttonClick()"
            [disabled]="true"
        ></app-icon-series-button>

        <app-checkbox labelKey="fietsbel"></app-checkbox>
    </div>

    <div class="box">
        <h2>Icons!</h2>
        @for (icon of allIcons; track icon; let index = $index) {
            <div class="icon-box font-overline">
                <p>Name: {{ icon[0] }}</p>
                <p>Normal:</p>
                <svg-icon [src]="icon[1]" class="icon"></svg-icon>
                <p>Color override:</p>
                <svg-icon [src]="icon[1]" class="icon override"></svg-icon>
                <p>Svg fill override: </p>
                <svg-icon [src]="icon[1]" class="icon svg-override"></svg-icon>
            </div>
        }
    </div>

    <div class="box">
        <h2>Validation!</h2>
        <form [formGroup]="form" (ngSubmit)="save()">
            <app-textfield
                id="email"
                formControlName="email"
                [value]="f.email.value"
                [placeholderKey]="'This is a placeholder text'"
                [fieldnameKey]="'app.modal.save.input.email.label'"
            ></app-textfield>
            @if (submittedAtLeastOnce && f.email.errors?.maxlength) {
                <span class="error-message font-body2"
                >{{ 'app.modal.save.input.email.max_length' | translate }}</span>
            }
            @if (submittedAtLeastOnce && f.email.errors?.required) {
                <span class="error-message font-body2"
                >{{ 'app.modal.save.input.email.valid' | translate }}</span>
            }
            @if (submittedAtLeastOnce && f.email.errors?.email) {
                <span class="error-message font-body2"
                >{{ 'app.modal.save.input.email.email' | translate }}</span>
            }
            <div class="button-container">
                <app-button class="modal-button"
                            [label]="'sla email op'"
                            [buttonType]="'primary'"
                            fillParent="true"
                            (onClick)="save()"
                            [clickDelay]="1000"
                ></app-button>
            </div>
        </form>
    </div>
</div>
